module.exports = function (images) {
        
    return images;
};

